export const enum TourId {
	// designer tour
	DESIGNER__INTRO = 'designer-intro',
	DESIGNER__DRAG_N_DROP = 'designer-drag-and-drop',
	DESIGNER__RESIZE_BLOCK = 'designer-resize-block',
	DESIGNER__MOVE_BLOCK = 'designer-move-block',
	DESIGNER__SELECT_VISUALIZATION = 'designer-select-visualization-type',
	DESIGNER__BOARD_MORE_MENU = 'designer-more-menu',
	DESIGNER__CHANGE_DATE_RANGE = 'designer-change-date-range',
	DESIGNER__ADD_TO_LOOP = 'designer-add-to-loop-databoard',
	DESIGNER__ADD_TO_REPORT = 'designer-add-to-report',
	DESIGNER__SHARABLE_LINK = 'designer-sharable-link',
	DESIGNER__MORE_OPTION = 'designer-more-option',
	DESIGNER__SELECT_DIMENSION = 'designer-select-dimension',

	// reports pageless tours
	REPORTS__PAGELESS_ADD_BLOCKS = 'reports-pageless-add-blocks',
	REPORTS__PAGELESS_ADD_COLUMN = 'reports-pageless-add-column',
	REPORTS__PAGELESS_CUSTOMIZE = 'reports-pageless-customize',
	REPORTS__PAGELESS_SHARE = 'reports-pageless-share',
	REPORTS__PAGELESS_VIEW_SWITCH = 'reports-pageless-view-switch',

	// reports slides tours
	REPORTS__CREATE_NEW_SLIDE = 'reports-create-new-slide',
	REPORTS__REORDER_SLIDES = 'reports-reorder-slides',
	REPORTS__ADD_NOTE = 'reports-add-note',
	REPORTS__PRESENT = 'reports-present',
	REPORTS__ADD_DATA_ELEMENT = 'reports-add-data-element',
	REPORTS__ADD_DATA_STORY = 'reports-add-data-story',
	REPORTS__CHANGE_DATA_STORY_SETTINGS = 'reports-change-data-story-settings',
	REPORTS__DOWNLOAD_PDF = 'reports-download-pdf',
	REPORTS__FAVORITE = 'reports-favorite',
	REPORTS__FIRST_PREVIEW = 'reports-first-preview',
	REPORTS__PLAN_PERFORMER = 'reports-plan-performer',
	REPORTS__PREVIEW_POPUP_EDIT = 'reports-preview-popup-edit',
	REPORTS__PREVIEW_POPUP_SHARE = 'reports-preview-popup-share',
	REPORTS__SELECT_DATA_ELEMENT = 'reports-select-data-element',
	REPORTS__SELECT_DATA_STORY = 'reports-select-data-story',

	// guided onboarding tours
	GUIDED_ONBOARDING__DATA_MANAGER_POPULAR = 'guided-onboarding-data-manager-popular',
	GUIDED_ONBOARDING__DATA_MANAGER_SELECTED = 'guided-onboarding-data-manager-selected',
	GUIDED_ONBOARDING__METRICS = 'guided-onboarding-metrics',
	GUIDED_ONBOARDING__WIZARD = 'guided-onboarding-wizard',

	// other tours
	CLIENT_PERFORMANCE = 'client-performance',
	CLIENTS_SETUP = 'clients-setup',
	FIRST_BOARD_EDIT = 'first-board-edit',
	FIRST_BOARD_SHARE = 'first-board-share',
	FIRST_BOARD_VIEW = 'first-board-view',
	METRICS_SOURCES = 'metrics-sources',
	ONBOARDING_CONNECT_SOURCE = 'onboarding-connect-source',
	ONBOARDING_CONTINUE_BUTTON = 'onboarding-continue-button',
	ONBOARDING_SOURCE = 'onboarding-source',
	CUSTOM_METRICS_POPUP_QB = 'custom-metrics-popup-qb',
	CUSTOM_METRICS_POPUP_SCRIPT = 'custom-metrics-popup-script',
	QB_SHEETS = 'qb-sheets',
	QB_SHEETS_VIDEO = 'qb-sheets-video',
	RECENTLY_DELETED = 'recently-deleted',
	SNAPSHOT = 'snapshot',
	WHITE_LABELING_PAYING_CUSTOMERS_PROMO = 'white-labeling-paying-customers-promo',
	WIZARD_DATABOARD_INTRO = 'wizard-databoard-intro',
	WIZARD_FIRST = 'wizard-first',
	WIZARD_SECOND = 'wizard-second',
	GENIE_CLIENT_SELECTOR = 'genie-client-selector',
	GENIE_CUSTOMIZE = 'genie-customize',
	GENIE_SKILLS = 'genie-skills',
	GENIE_ARTIFACT_EDIT = 'genie-artifact-edit',
}

export const enum TourDoneKey {
	// designer tour
	DESIGNER__INTRO = 'designer_intro',
	DESIGNER__DRAG_N_DROP = 'designer_drag_and_drop',
	DESIGNER__RESIZE_BLOCK = 'designer_resize_block',
	DESIGNER__MOVE_BLOCK = 'designer_move_block',
	DESIGNER__SELECT_VISUALIZATION = 'designer_select_visualization_type',
	DESIGNER__BOARD_MORE_MENU = '',
	DESIGNER__CHANGE_DATE_RANGE = 'designer_change_date_range',
	DESIGNER__ADD_TO_LOOP = 'designer_add_to_loop_databoard',
	DESIGNER__ADD_TO_REPORT = 'designer_add_to_report',
	DESIGNER__SHARABLE_LINK = 'designer_sharable_link',
	DESIGNER__MORE_OPTION = 'designer_more_option',
	DESIGNER__SELECT_DIMENSION = 'designer_select_dimension',

	// reports pageless tours
	REPORTS__PAGELESS_ADD_BLOCKS = 'reports_pageless_add_blocks',
	REPORTS__PAGELESS_ADD_COLUMN = 'reports_pageless_add_column',
	REPORTS__PAGELESS_CUSTOMIZE = 'reports_pageless_customize',
	REPORTS__PAGELESS_SHARE = 'reports_pageless_share',
	REPORTS__PAGELESS_VIEW_SWITCH = 'reports_pageless_view_switch',

	// reports slides tours
	REPORTS__CREATE_NEW_SLIDE = 'reports_create_new_slide',
	REPORTS__REORDER_SLIDES = 'reports_reorder_slides',
	REPORTS__ADD_NOTE = 'reports_add_note',
	REPORTS__PRESENT = 'reports_present',

	// other tours
	// ...
}

function getTourDoneKeyFromTourId(tourId: TourId): string {
	switch (tourId) {
		case TourId.DESIGNER__INTRO:
			return TourDoneKey.DESIGNER__INTRO;
		case TourId.DESIGNER__DRAG_N_DROP:
			return TourDoneKey.DESIGNER__DRAG_N_DROP;
		case TourId.DESIGNER__RESIZE_BLOCK:
			return TourDoneKey.DESIGNER__RESIZE_BLOCK;
		case TourId.DESIGNER__MOVE_BLOCK:
			return TourDoneKey.DESIGNER__MOVE_BLOCK;
		case TourId.DESIGNER__SELECT_VISUALIZATION:
			return TourDoneKey.DESIGNER__SELECT_VISUALIZATION;
		case TourId.DESIGNER__BOARD_MORE_MENU:
			return TourDoneKey.DESIGNER__BOARD_MORE_MENU;
		case TourId.DESIGNER__CHANGE_DATE_RANGE:
			return TourDoneKey.DESIGNER__CHANGE_DATE_RANGE;
		case TourId.DESIGNER__ADD_TO_LOOP:
			return TourDoneKey.DESIGNER__ADD_TO_LOOP;
		case TourId.DESIGNER__ADD_TO_REPORT:
			return TourDoneKey.DESIGNER__ADD_TO_REPORT;
		case TourId.DESIGNER__SHARABLE_LINK:
			return TourDoneKey.DESIGNER__SHARABLE_LINK;
		case TourId.DESIGNER__MORE_OPTION:
			return TourDoneKey.DESIGNER__MORE_OPTION;
		case TourId.DESIGNER__SELECT_DIMENSION:
			return TourDoneKey.DESIGNER__SELECT_DIMENSION;

		// reports pageless tours
		case TourId.REPORTS__PAGELESS_ADD_BLOCKS:
			return TourDoneKey.REPORTS__PAGELESS_ADD_BLOCKS;
		case TourId.REPORTS__PAGELESS_ADD_COLUMN:
			return TourDoneKey.REPORTS__PAGELESS_ADD_COLUMN;
		case TourId.REPORTS__PAGELESS_CUSTOMIZE:
			return TourDoneKey.REPORTS__PAGELESS_CUSTOMIZE;
		case TourId.REPORTS__PAGELESS_SHARE:
			return TourDoneKey.REPORTS__PAGELESS_SHARE;
		case TourId.REPORTS__PAGELESS_VIEW_SWITCH:
			return TourDoneKey.REPORTS__PAGELESS_VIEW_SWITCH;

		// reports slides tours
		case TourId.REPORTS__CREATE_NEW_SLIDE:
			return TourDoneKey.REPORTS__CREATE_NEW_SLIDE;
		case TourId.REPORTS__REORDER_SLIDES:
			return TourDoneKey.REPORTS__REORDER_SLIDES;
		case TourId.REPORTS__ADD_NOTE:
			return TourDoneKey.REPORTS__ADD_NOTE;
		case TourId.REPORTS__PRESENT:
			return TourDoneKey.REPORTS__PRESENT;

		default:
			return '';
	}
}

export { getTourDoneKeyFromTourId };
